/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import { hamburgerIcon } from "../../../../v1/blocks/WidgetValues/Hamburger";
import HamburgerCore from "../../../../v1/blocks/WidgetValues/Hamburger/HamburgerCore";

export const BLOCK_NAME = 'snap_open_hamburger';

function defineBlock(context) {
    let blockInstance = HamburgerCore(context);
    Object.assign(blockInstance, {
        init: function () {
            this.loadOptions();
            this.appendDummyInput('WIDGET')
                .appendField("open")
                .appendField(new Blockly.FieldImage(hamburgerIcon, 30, 30, "hamburger icon", null), 'hamburgerIcon')
                .appendField(new Blockly.FieldDropdown(this.options), this.fieldHamburgerId);

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Open a hamburger menu.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#hamburger-menu`);
            this.setOnChange(this.changeHandler);
        }
    });
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const hamburgerId = block.getSelectedWidgetId();
            return `Snap.hamburgers.open(${hamburgerId});\n`;
        }
    }
}

const OpenHamburger = function (props) {
    const name = BLOCK_NAME;
    OpenHamburger.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return props.context.hamburgers.length ? <block type={name}></block> : null;
}

OpenHamburger.propTypes = {
    context: PropTypes.shape({
        hamburgers: PropTypes.arrayOf(PropTypes.object)
    })
};

export default OpenHamburger;
